import { APP_DATA_SOURCE_SELECTION } from "app/action_types/app_intelligence_action_types";
import type { AppDataSources } from "app/pages/app-intelligence/common-components/app-solution-toggle/AppSolutionToggle";

export const appDataSourceSelected = (selectedDataSource: AppDataSources) => {
    return {
        type: APP_DATA_SOURCE_SELECTION,
        payload: selectedDataSource,
    };
};
